import { FC } from 'react';
import { Button } from '@mui/material';
import SecondTypeButton from '../button/SecondTypeButton';

interface IProps {
  handleClose: () => void;
  handleSubmit: () => void;
  type: string;
  action: string;
  isDisable?: boolean;
}

const ModalAction: FC<IProps> = ({
  handleClose,
  handleSubmit,
  type,
  action,
  isDisable
}) => {

  return (
    <div className='col-2' style={{ marginTop: '30px' }}>
      <SecondTypeButton
        children='Cancel'
        onClick={() => handleClose()}
      />
      <Button
        variant='contained'
        onClick={handleSubmit}
        children={`${action} ${type}`}
        disabled={isDisable}
      />
    </div>
  );
};

export default ModalAction;
